/**
 * Shop the look (sections/cvx-shop-the-look.liquid). Behaviour carried over from A/B test #705.
 *
 * Computer: hovering a dot previews the product, clicking opens the product page.
 * Touch: the first tap on a dot previews, the second tap (or a tap on the card) opens it.
 * "+" adds one product, the add-all button adds every in-stock product, both via CartJS.
 */
(function () {
  "use strict";

  function canHover() {
    return window.matchMedia("(hover: hover)").matches;
  }

  /* ---------------------------------------------------------------- *
   * Basket - USE CartJS, NOT A PLAIN POST TO /cart/add.js.
   *
   * The basket drawer's panels are Rivets bindings on CartJS's own model
   * (rv-show="cart.item_count | gt 0"). A direct POST adds the items but the
   * drawer opens reading "YOUR BASKET IS EMPTY", and firing the theme's
   * cart.requestComplete does not fix it. CartJS.addItems updates the model and
   * the theme does the rest: counter, shipping progress, opening the drawer.
   * ---------------------------------------------------------------- */

  function addItems(items) {
    return new Promise(function (resolve, reject) {
      var jq = window.jQuery || window.$;
      var lib = window.CartJS;
      if (!jq || !lib || typeof lib.addItems !== "function") {
        return reject(new Error("The basket is not ready yet, please try again."));
      }

      var settled = false;
      function finish(error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        jq(document).off("cart.requestComplete", onDone);
        jq(document).off("cart.requestError", onFail);
        if (error) reject(error);
        else resolve();
      }
      function onDone() {
        finish(null);
      }
      function onFail(event, jqxhr) {
        var body = jqxhr && jqxhr.responseJSON;
        finish(new Error((body && body.description) || "Could not add to basket."));
      }

      jq(document).on("cart.requestComplete", onDone);
      jq(document).on("cart.requestError", onFail);
      // Never leave a button spinning if the library goes quiet.
      var timer = setTimeout(function () {
        finish(new Error("The basket did not respond, please try again."));
      }, 15000);

      try {
        lib.addItems(items);
      } catch (error) {
        finish(error);
      }
    });
  }

  function init(root) {
    if (root.cvxStl) return;
    root.cvxStl = true;

    var figure = root.querySelector(".cvx-stl-figure");
    var media = root.querySelector(".cvx-stl-media");
    var dots = root.querySelectorAll(".cvx-stl-dot");
    var pop = root.querySelector(".cvx-stl-pop");
    if (!figure || !pop) return;

    var popImg = pop.querySelector("img");
    var popVendor = pop.querySelector(".cvx-stl-v");
    var popTitle = pop.querySelector(".cvx-stl-t");
    var popPrice = pop.querySelector(".cvx-stl-p");

    popImg.addEventListener("load", function () {
      popImg.classList.remove("is-loading");
    });

    // Warm the card photos once the section is near the screen, so a hover or tap shows its
    // photo straight away.
    if ("IntersectionObserver" in window) {
      var warm = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        warm.disconnect();
        Array.prototype.forEach.call(dots, function (dot) {
          if (dot.dataset.image) new Image().src = dot.dataset.image;
        });
      }, { rootMargin: "300px" });
      warm.observe(root);
    }

    var openIndex = -1;
    // Which dot a TAP has previewed. Separate from openIndex on purpose: a tap
    // focuses the anchor before it clicks, so "is the card open" cannot tell
    // whether the shopper has actually had their preview yet.
    var tappedIndex = -1;
    var busy = false;

    function rowPrice(index) {
      var row = root.querySelector('.cvx-stl-row[data-index="' + index + '"] .cvx-stl-p');
      var price = row && row.querySelector(".discount-new-price, .new-price, .price");
      return price ? price.textContent.replace(/\s+/g, " ").trim() : "";
    }

    function showPop(index) {
      var dot = dots[index];
      if (!dot) return;

      // Hide the previous product's photo until this one has loaded, or the card
      // briefly shows one product's name over another's picture.
      if (popImg.getAttribute("src") !== dot.dataset.image) {
        popImg.classList.add("is-loading");
        popImg.src = dot.dataset.image || "";
      }
      popImg.hidden = !dot.dataset.image;
      popVendor.textContent = dot.dataset.vendor || "";
      popTitle.textContent = dot.dataset.title || "";
      popPrice.textContent = rowPrice(index);
      pop.setAttribute("href", dot.getAttribute("href"));

      // Position from the dot's rendered spot, which already reflects the mobile position.
      var photo = media.getBoundingClientRect();
      var box = dot.getBoundingClientRect();
      var x = ((box.left + box.width / 2 - photo.left) / photo.width) * 100;
      var dotFromTop = box.top + box.height / 2 - photo.top;

      // Keep the card inside the photo near the edges.
      pop.style.left = Math.min(Math.max(x, 15), 85) + "%";
      pop.style.top = (dotFromTop / photo.height) * 100 + "%";

      // Above or below: measure the card against the room above the dot.
      pop.classList.remove("is-below");
      pop.classList.add("is-on");
      if (dotFromTop - 24 - pop.getBoundingClientRect().height < 0) {
        pop.classList.add("is-below");
      }
      pop.setAttribute("aria-hidden", "false");

      openIndex = index;
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle("is-active", i === index);
    }

    function hidePop() {
      pop.classList.remove("is-on");
      pop.setAttribute("aria-hidden", "true");
      openIndex = -1;
      tappedIndex = -1;
      for (var i = 0; i < dots.length; i++) dots[i].classList.remove("is-active");
    }

    Array.prototype.forEach.call(dots, function (dot, index) {
      dot.addEventListener("mouseenter", function () {
        if (canHover()) showPop(index);
      });
      // Focus previews only on hover devices - on a phone, focus fires before
      // the click and would let the first tap navigate away.
      dot.addEventListener("focus", function () {
        if (canHover()) showPop(index);
      });
      dot.addEventListener("mouseleave", function () {
        if (canHover()) hidePop();
      });
      dot.addEventListener("blur", function () {
        if (canHover()) hidePop();
      });
    });

    figure.addEventListener("mouseleave", function () {
      if (canHover()) hidePop();
    });

    // Touch: a tap anywhere else closes the card.
    document.addEventListener("click", function (event) {
      if (canHover() || openIndex === -1) return;
      if (event.target.closest(".cvx-stl-dot, .cvx-stl-pop")) return;
      hidePop();
    });

    function add(items, button) {
      if (busy || !items.length) return;
      busy = true;
      root.classList.add("is-busy");
      button.disabled = true;

      var original = button.textContent;
      var isAll = button.hasAttribute("data-cvx-stl-all");
      if (isAll) button.textContent = "Adding...";

      addItems(items)
        .then(function () {
          if (isAll) return;
          // Brief confirmation on the "+" - the drawer opening is the main feedback.
          button.classList.add("is-added");
          button.textContent = "✓";
          setTimeout(function () {
            button.classList.remove("is-added");
            button.textContent = original;
          }, 1200);
        })
        .catch(function (error) {
          window.alert(error.message);
        })
        .then(function () {
          busy = false;
          root.classList.remove("is-busy");
          button.disabled = false;
          if (isAll) button.textContent = original;
        });
    }

    root.addEventListener("click", function (event) {
      var all = event.target.closest("[data-cvx-stl-all]");
      if (all) {
        event.preventDefault();
        var ids = (all.getAttribute("data-ids") || "").split(",").filter(Boolean);
        add(
          ids.map(function (id) {
            return { id: Number(id), quantity: 1 };
          }),
          all
        );
        return;
      }

      var one = event.target.closest("[data-cvx-stl-add]");
      if (one) {
        event.preventDefault();
        add([{ id: Number(one.getAttribute("data-cvx-stl-add")), quantity: 1 }], one);
        return;
      }

      // Touch: the first tap on a dot is a preview, not a navigation.
      var dot = event.target.closest(".cvx-stl-dot");
      if (dot && !canHover()) {
        var index = Number(dot.dataset.index);
        if (tappedIndex !== index) {
          event.preventDefault();
          showPop(index);
          tappedIndex = index;
        }
        return;
      }

      var card = event.target.closest(".cvx-stl-pop");
      if (card && card.getAttribute("href") === "#") event.preventDefault();
    });

    // Theme editor: selecting a hotspot block previews its dot, so its position is easy to check.
    root.cvxStlSelect = function (blockId) {
      for (var i = 0; i < dots.length; i++) {
        if (dots[i].dataset.block === blockId) return showPop(i);
      }
    };
    root.cvxStlDeselect = hidePop;
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-cvx-stl]"), init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:block:select", function (event) {
    var root = event.target.closest("[data-cvx-stl]");
    if (root && root.cvxStlSelect) root.cvxStlSelect(event.detail.blockId);
  });
  document.addEventListener("shopify:block:deselect", function (event) {
    var root = event.target.closest("[data-cvx-stl]");
    if (root && root.cvxStlDeselect) root.cvxStlDeselect();
  });
})();
